// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import config from '@nerdwallet/app-config';

import { httpClient } from './nw-api-sdk';
import getErrorHandlers from './error-handling';
import { CC_PREQUAL_SERVICE_ERROR_MSG } from './errors';
import { logInfo, logWarn } from './logging-utils';

export default async ({ postData = {}, req, res, store }) => {
  const { handleServerError } = getErrorHandlers({
    req,
    res,
    store,
    service: config.CC_PREQUAL_URL,
  });

  const requestBody = {
    user: {
      ...postData,
    },
  };
  const issuers = JSON.stringify(postData.issuers);
  const ccPrequalBase = config.CC_PREQUAL_URL;
  const ccPrequalRedirectUrl = `${ccPrequalBase}/send_verify_data/`;
  const fetchArgs = {
    method: 'POST',
    url: ccPrequalRedirectUrl,
    json: requestBody,
    serverRequest: req,
    // cc-prequal-service expects the X-PREQUAL-COOKIE-ID to be passed through
    cookies: req.cookies,
  };

  let result;
  try {
    result = await httpClient.fetch(fetchArgs);
  } catch (e) {
    // Request failed (e.g. connectivity issues)
    const connectionError = new Error(
      `${CC_PREQUAL_SERVICE_ERROR_MSG} for ${issuers}: ${e.message}`
    );
    handleServerError({
      product: {
        id: postData.click_id,
        category: 'prequalify/credit-cards',
        productType: 'credit_cards',
      },
      error: connectionError,
    });
    throw connectionError;
  }

  const { response, body } = result;
  // Non-404 server errors
  if (body.error && response.statusCode !== 404) {
    const message = get(body, 'error.data.internal_message');
    const type = get(body, 'error.type');
    const serverError = new Error(
      `${CC_PREQUAL_SERVICE_ERROR_MSG} for ${issuers}: [${type}] ${message}`
    );
    handleServerError({
      product: {
        id: postData.click_id,
        category: 'prequalify/credit-cards',
        productType: 'credit_cards',
      },
      error: serverError,
    });
    throw serverError;
  } else {
    // Otherwise, return the data. Caller will decide how to handle undefined data
    const { data } = body;
    if (data === undefined) {
      logWarn(req, 'sendverify-not-defined', {
        product_type: 'credit_cards',
        service: config.CC_PREQUAL_URL,
        issuers: postData.issuers,
        message: get(body, 'error.data.internal_message'),
      });
    } else {
      logInfo(req, 'log-sendverify-response', data);
    }
    return data;
  }
};
